import { DocumentData } from "../utils/state";
import { classNames } from "../utils/utils";
import DangerousHtml from 'dangerously-set-html-content';
import { OpenIcon, DownloadIcon, CopyIcon, DeleteIcon, AddIcon } from "../utils/iconFactory";
import Tooltip from "./Elements/Tooltip";
interface DocumentCardSmallProps {
  key: number;
  item: DocumentData;
  handleChangeDocument: (id:string) => void;
}

export function DocumentCardSmall({key, item, handleChangeDocument}: DocumentCardSmallProps) {
  const formatDate = (dateString:string) => {
    const userLocale = navigator.language;
    const formattedDate = new Date(dateString).toLocaleString(userLocale, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });
    const customDateString = formattedDate.replace(/\//g, '.');

    return customDateString
  }
 
  return (
    <div
      id='document-card'
      key={key}
      className={classNames("flex flex-col justify-between cursor-pointer rounded-[16px] h-[222px] w-[384px] overflow-hidden",
        "p-6 gap-6 bg-backgroundWhite border border-backgroundDarkGray card-drop-shadow",
        "hover:border-primaryActionAltHover card-hover-drop-shadow")}
      onClick={() => {handleChangeDocument(item.id)}}
    >
      <div id='card-data' className="relative flex flex-col h-full justify-between">
        <div id='wrapper' className="h-[126px] overflow-hidden" >
          <h1 id='header' className="text-style-sub1 text-textMain truncate">{item.name}</h1>
          <p id='data' className="whitespace-normal pt-6 text-textSecondary text-style-body2 break-words truncate">{<DangerousHtml  html={item.data} />}</p>
        </div>
        <p id='date-footer' className="text-gray100 text-style-body2">{"Dátum: "}{formatDate(item.date)}</p>
      </div>
    </div>
  )
}

interface DocumentCardProps {
  key: number;
  item: DocumentData;
  open: () => void;
  download: () => void;
  copy: () => void;
  _delete: () => void;
}

export function DocumentCard({key, item, open, download, copy, _delete}: DocumentCardProps) {
  const formatDate = (dateString:string) => {
    const userLocale = navigator.language;
    const formattedDate = new Date(dateString).toLocaleString(userLocale, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });
    const customDateString = formattedDate.replace(/\//g, '.');

    return customDateString
  }
 
  return (
    <div
      id='document-card'
      key={key}
      className={classNames(" flex flex-col justify-between rounded-[16px] h-[320px] w-[436px]",
        "p-6 gap-6 bg-backgroundWhite border border-backgroundDarkGray card-drop-shadow cursor-pointer",
        "hover:border-primaryActionAltHover card-hover-drop-shadow")}
      onClick={open}
    >
      <main id='main-content' className="relative h-full w-full" >
        <div id='card-data' className="flex flex-col justify-between h-[206px]">
          <div id='wrapper' className="h-[150px] overflow-hidden" >
            <h1 id='header' className="text-style-sub1 text-textMain truncate">{item.name}</h1>
            <p id='data' className="whitespace-normal pt-6 text-textSecondary text-style-body2 break-words truncate">{<DangerousHtml  html={item.data} />}</p>
          </div>
          <p id='date-footer' className="text-gray100 text-style-body2">{"Dátum: "}{formatDate(item.date)}</p>
        </div>
        <div id='footer' className="absolute -bottom-1.5 flex justify-between w-full pt-4 border-t border-gray10" >
          <div id='left' className="flex gap-4">
            <button id="toEditor" onClick={(e) => {e.stopPropagation(); open()}} className="relative group transform duration-150 active:scale-75" >
              <Tooltip message="Dokumentum megnyitása" />
              <OpenIcon className="h-8 w-8 text-primaryAction fill-current" />
            </button>
            <button id="download" onClick={(e) => {e.stopPropagation(); download()}} className="relative group transform duration-150 active:scale-75" >
              <Tooltip message="Dokumentum letöltése (.doc)" />
              <DownloadIcon className="h-8 w-8 text-primaryAction fill-current" />
            </button>
            <button id="copy" onClick={(e) => {e.stopPropagation(); copy()}} className="relative group transform duration-150 active:scale-75" >
              <Tooltip message="Vágólapra másolás" />
              <CopyIcon className="h-8 w-8 text-primaryAction fill-current" />
            </button>
          </div>
          <div id='right' className="group">
            <button id='delete' onClick={(e) => {e.stopPropagation(); _delete()}} className="transform duration-150 active:scale-75" ><DeleteIcon className="h-8 w-8 text-gray50 group-hover:text-tertiaryRedDarker fill-current" /></button>
          </div>
        </div>
      </main>
    </div>
  )
}

interface NewDocumentCardProps {
  onClick: () => void;
}

export function NewDocumentCard({onClick}: NewDocumentCardProps) {
  return (
    <div id="new-document" className={classNames("flex flex-col items-center gap-6 h-[228px] w-[262px] rounded-[16px] px-6 py-8",
        "bg-backgroundWhite border border-backgroundDarkGray card-drop-shadow cursor-pointer",
        "hover:border-primaryActionAltHover card-hover-drop-shadow")}
      onClick={onClick}
    >
      <button className={classNames("flex justify-center items-center h-[80px] w-[80px] rounded-full",
          "bg-primaryAction primary-button-drop-shadow hover:bg-primaryActionBtnHover primary-button-hover-shadow")}
      >
        <AddIcon className="h-[41.6px] w-[41.6px] text-backgroundWhite fill-current" />
      </button>
      <p id="label" className="text-center text-textMain text-style-sub1">Új dokumentum hozzáadása</p>
    </div>
  )
}